import { render, staticRenderFns } from "./Cookie2022.vue?vue&type=template&id=48dd4692&scoped=true&"
import script from "./Cookie2022.vue?vue&type=script&lang=js&"
export * from "./Cookie2022.vue?vue&type=script&lang=js&"
import style0 from "./Cookie2022.vue?vue&type=style&index=0&id=48dd4692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dd4692",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Markomat-Client\\botaliberec-shop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48dd4692')) {
      api.createRecord('48dd4692', component.options)
    } else {
      api.reload('48dd4692', component.options)
    }
    module.hot.accept("./Cookie2022.vue?vue&type=template&id=48dd4692&scoped=true&", function () {
      api.rerender('48dd4692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cookie2022.vue"
export default component.exports